<template>
<div class="chapter">
<div class="inner_page">
<a id="page_5"></a>
<h3 class="chap-num">One</h3>
<h3 class="chap-title">The little room</h3>
<p class="noindent">‘Who can be certain where the end begins?’ said Dad, shortly before he was arrested for the murder of the carpenter.</p>
<p class="indent">‘Time is growing,’ he added. ‘And our suffering is growing too. When will our suffering bear fruit? One great thought can alter the future of the world. One revelation. One dream. But who will dream that dream? And who will make it real?’</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 007_Part01Sub01Ch01.vue?3b4845a8